import { addBreadcrumb, captureException } from '@sentry/browser';
export class SentryTransport {
    constructor() {
        this.id = SentryTransport.id;
    }
    log(loggerName, level, ...args) {
        if (level === 'error') {
            const [err, ...rest] = SentryTransport.translateError(args);
            captureException(err, {
                tags: {
                    loggerName
                },
                extra: {
                    arguments: rest
                }
            });
        }
        else {
            addBreadcrumb(Object.assign({ category: 'console.' + loggerName, level: SentryTransport.translateLevel(level) }, SentryTransport.translateArgs(args)));
        }
    }
    static translateError(args) {
        // Find first Error or create an "unknown" Error to keep stack trace.
        const foundError = args.find((arg) => arg instanceof Error);
        const err = foundError !== null && foundError !== void 0 ? foundError : new Error(typeof args[0] === 'string' ? args[0] : 'unknown error');
        return [err, args];
    }
    static translateArgs(args) {
        const [firstArg, ...otherArgs] = args;
        if (typeof firstArg === 'string') {
            const translated = {
                message: firstArg
            };
            if (otherArgs.length) {
                translated.data = {
                    arguments: otherArgs
                };
            }
            return translated;
        }
        return {
            data: {
                arguments: otherArgs
            }
        };
    }
    static translateLevel(level) {
        switch (level) {
            case 'info':
                return 'info';
            case 'error':
                return 'error';
            case 'warn':
                return 'warning';
            default:
                return 'debug';
        }
    }
}
SentryTransport.id = Symbol('Sentry');
